import { render, staticRenderFns } from "./FileTypeValidator.vue?vue&type=template&id=6f5aa136&"
import script from "./FileTypeValidator.vue?vue&type=script&lang=ts&"
export * from "./FileTypeValidator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports